import {InjectionToken} from "@angular/core";

export const INT_CALENDAR_DAYS_COLLECTION = new InjectionToken<Array<string>>('INT_CALENDAR_DAYS_COLLECTION', {
  factory() {
    return ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  }
})
